import React, {useCallback, useContext} from 'react';

import {ActionWithReasonButton} from 'src/components/save-with-reason/action-with-reason-button';
import {MessageContext} from 'src/contexts/message-context';
import {useAdminAccessRight} from 'src/hooks/access-rights';

import {useDeleteUser} from './useDeleteUser';

import type {ActionWithReason} from 'src/components/save-with-reason/action-with-reason-button';

type Props = {
    userId: number,
    accountId: number,
    onDone: () => void,
};

export const DeleteUser = ({userId, accountId, onDone}: Props) => {
    const {setSuccessMessage} = useContext(MessageContext);
    const {canDeleteUser} = useAdminAccessRight();
    const onSuccess = useCallback(() => {
        setSuccessMessage('User is successfully deleted');
        onDone();
    }, [onDone, setSuccessMessage]);
    const {event, busy} = useDeleteUser({userId, onSuccess});
    const onConfirm = useCallback<ActionWithReason>(async options => (await event(options)) || undefined, [event]);

    return canDeleteUser(accountId) ? (
        <ActionWithReasonButton
            action="Delete"
            variant="Type.SECONDARY"
            colorVariant="ERROR"
            busy={busy}
            onConfirm={onConfirm}
            confirmation={{
                title: 'Delete User',
                message: 'Are you sure you want to delete this user? Note: User can be restored.',
                width: 420,
            }}
        />
    ) : null;
};
